module.exports = __webpack_public_path__ + "static/img/swiper1.bfbce24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/subcomponent/courseList/img/swiper1.png
// module id = 6OLw
// module chunks = 96